<p-toast position="top-right" key="tr"
[showTransformOptions]="'translateY(100%)'"
[showTransitionOptions]="'200ms'"
[hideTransitionOptions]="'200ms'"
[showTransformOptions]="'translateX(100%)'"></p-toast>
<router-outlet></router-outlet>
